import React, { useCallback, useEffect, useLayoutEffect, useState } from 'react'
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import {
    getEmployeeAttendanceByEmployeeIdAndDateRangeAsync, getAccountEmployeesForDropDownAsync, getShiftPermissionsAsync,
    addAttendanceAsync, getBreaksAsync, getLastAttendanceAsync, checkPermissionsForAttendanceAsync,
    updateIsLoading,
    AttendanceAsync,
    getLastAttendanceBySystemAttendanceIdAsync
} from "./AttendanceSlice";
import { getSystemTimeZone, getValueFromResource } from '../../common/timeLiveFunction';
import { ShowToast } from '../../common/Toastr';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import moment from 'moment';
import { useDebounce } from '../../_metronic/helpers';
import { getPagePermissionsAsync } from '../../common/GlobalSlice';
import { useLocation, useNavigate } from 'react-router-dom';
import './Attendance.css'

const itemClass = 'ms-1 ms-lg-3';
const TimeinTimeout = () => {
    const { attendanceList, isReload, selectedRecord, employeeList, startDateAttendance, endDateAttendance, isAllowedLocationInWeb, resultId, CanCheckOut, CanEndBreak,
        CanStartBreak, breakList, isLoading, pageNo, pageSize, totalItems, isSearch, start, startRec, recordsFiltered, direction, columnIndex, search, sortOrder, sortColumn, ActiveBreakId } = useAppSelector((state) => state.attendance)
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const [time, setTime] = useState(new Date());
    const navigate = useNavigate();
    const location = useLocation();
    const [isFirstTimeLoad, setIsFirstTimeLoad] = useState(true);
    const [isGetAttendance, setIsGetAttendance] = useState(false);
    const { pageId, menuList, maxMenuHeight, masterAccountRoleId, ProfileTimeZoneIANA, IsAdd } = useAppSelector((state) => state.globalState);
    const [isOpen, setIsOpen] = useState(false);
    const toggleMenu = () => setIsOpen(!isOpen);
    const [activeAccountBreakId, setActiveAccountBreakId] = useState<any>(0);
    const AccountId = localStorage.getItem('accountId');
    const AccountEmployeeId = localStorage.getItem('accountEmployeeId');

    const debouncedSearchTerm = useDebounce(search, 500);
    useEffect(() => {
        if (!isFirstTimeLoad) {
            const commaSeparatedValues = employeeList.filter((item: any) => item.isSelected == 1).map((item: any) => item.value).join(', ');
            let SearchParamsValues = { page: pageNo, pageSize: pageSize, start: startRec, Order: sortColumn, OrderDir: sortOrder, search: debouncedSearchTerm, StartDate: `${moment(startDateAttendance).format('MM-DD-YYYY')}`, EndDate: `${moment(endDateAttendance).format('MM-DD-YYYY')}`, AccountEmployeeIds: `${commaSeparatedValues.length === 0 ? "0" : commaSeparatedValues}` };
            dispatch(getEmployeeAttendanceByEmployeeIdAndDateRangeAsync(SearchParamsValues));
        }
    }, [debouncedSearchTerm]);

    useEffect(() => {
        dispatch(getAccountEmployeesForDropDownAsync())
            .unwrap()
            .then((originalPromiseResult) => {
                const commaSeparatedValues = originalPromiseResult.filter((item: any) => item.isSelected == 1).map((item: any) => item.value).join(', ');
                let SearchParamsValues = { page: pageNo, pageSize: pageSize, start: startRec, Order: sortColumn, OrderDir: direction, search: " ", StartDate: `${moment(startDateAttendance).format('MM-DD-YYYY')}`, EndDate: `${moment(endDateAttendance).format('MM-DD-YYYY')}`, AccountEmployeeIds: `${commaSeparatedValues.length === 0 ? "0" : commaSeparatedValues}` };
                dispatch(getEmployeeAttendanceByEmployeeIdAndDateRangeAsync(SearchParamsValues));
                setIsFirstTimeLoad(false);
            }).catch((rejectedValueOrSerializedError) => {

            })

        dispatch(checkPermissionsForAttendanceAsync());
        dispatch(getLastAttendanceBySystemAttendanceIdAsync(getSystemAttendanceTypeId("Attendance"))).then((result) => {
            dispatch(getBreaksAsync(moment().format("YYYY-MM-DD")));
        })
        // dispatch(getLastAttendanceAsync(getSystemAttendanceTypeId("Attendance"))).then((result) => {
        //     dispatch(getBreaksAsync(moment().format("YYYY-MM-DD")));
        // })
        const timerId = setInterval(() => {
            setTime(new Date());
        }, 1000);
        return () => clearInterval(timerId);
    }, []);

    useEffect(() => {
        if (isGetAttendance) {
            // dispatch(getLastAttendanceAsync(getSystemAttendanceTypeId("Attendance")));
            dispatch(getLastAttendanceBySystemAttendanceIdAsync(getSystemAttendanceTypeId("Attendance")));
            dispatch(updateIsLoading(false));
            setIsGetAttendance(false);
        }
    }, [isGetAttendance]);

    useLayoutEffect(() => {
        const fetchPagePermissions = async () => {
            if (pageId && pageId !== '') {
                const res = await dispatch(getPagePermissionsAsync(pageId));
                if (!res.payload.IsList) {
                    // navigate('../error/403');
                }
            } else if (!pageId && menuList && menuList.length > 0) {
                const routeName = location.pathname.split('/').filter(Boolean)[0];
                const foundItem = menuList.find(item => item.SystemCategoryPageFrontEnd.toLowerCase() === routeName.toLowerCase());
                if (foundItem) {
                    const res = await dispatch(getPagePermissionsAsync(foundItem.SystemSecurityCategoryPageId));
                    if (!res.payload.IsList) {
                        //   navigate('../error/403');
                    }
                } else {
                    // navigate('../error/403');
                }
            }
        }
        fetchPagePermissions();
    }, [dispatch, location.pathname, menuList, navigate, pageId]);

    const isTimeZoneMismatched = useCallback(() => {
        const systemTZ = getSystemTimeZone();
        if (systemTZ?.trim().toLowerCase() !== ProfileTimeZoneIANA?.trim().toLowerCase()) {
            ShowToast('Error', 'System and TimeLive profile time zone must match.', "error", "toast-top-right");
            return true;
        }
        return false;
    }, [ProfileTimeZoneIANA]);

    const getDeviceInformation = () => {
        const ua = navigator.userAgent;

        // ----- OS -----
        let os = "Unknown";
        if (ua.indexOf("Win") !== -1) os = "Windows";
        else if (ua.indexOf("Mac") !== -1) os = "MacOS";
        else if (ua.indexOf("Linux") !== -1) os = "Linux";
        else if (/Android/.test(ua)) os = "Android";
        else if (/iPhone|iPad|iPod/.test(ua)) os = "iOS";

        // ----- Browser + Version -----
        let browser = "Unknown";
        let version = "Unknown";

        if (/Edg\/([0-9.]+)/.test(ua)) {
            browser = "Edge";
            version = ua.match(/Edg\/([0-9.]+)/)?.[1] || "Unknown";
        } else if (/Chrome\/([0-9.]+)/.test(ua) && !/Edg/.test(ua)) {
            browser = "Chrome";
            version = ua.match(/Chrome\/([0-9.]+)/)?.[1] || "Unknown";
        } else if (/Firefox\/([0-9.]+)/.test(ua)) {
            browser = "Firefox";
            version = ua.match(/Firefox\/([0-9.]+)/)?.[1] || "Unknown";
        } else if (/Safari\/([0-9.]+)/.test(ua) && /Version\/([0-9.]+)/.test(ua)) {
            browser = "Safari";
            version = ua.match(/Version\/([0-9.]+)/)?.[1] || "Unknown";
        }

        return `${os}/${version}/${browser} `;
    };

    const getUserLocation = (attendanceStatus: any, accountBreakId: any) => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    addAttendanceByLocation(position.coords.latitude, position.coords.longitude, attendanceStatus, accountBreakId)
                },
                (error) => {
                }
            );
        } else {
        }
    }

    const addAttendanceByLocation = (latitude: any, longitude: any, attendanceStatus: any, accountBreakId: any) => {
        if (attendanceStatus === 0) {
            if (latitude != null && latitude != "" && latitude != 0) {
                addAttendance(getSystemAttendanceTypeId("Attendance"), 1, 0, latitude, longitude);
            }
            else {
                showLocationMessage();
            }
        }
        else if (attendanceStatus === 1) {
            if (latitude != null && latitude != "" && latitude != 0) {
                addAttendance(getSystemAttendanceTypeId("Break"), 3, accountBreakId, latitude, longitude);
            }
            else {
                showLocationMessage();
            }
        }
        else if (attendanceStatus === 2) {
            if (latitude != null && latitude != "" && latitude != 0) {
            }
            else {
                showLocationMessage();
            }
        }
        else {
            showLocationMessage();
        }
    }

    const handleAutoClockIn = () => {
        const systemTZ = getSystemTimeZone();

        if (systemTZ?.trim().toLowerCase() !== ProfileTimeZoneIANA?.trim().toLowerCase()) {
            ShowToast('Error', 'System and TimeLive profile time zone must match.', "error", "toast-top-right");
            return;
        }

        dispatch(getShiftPermissionsAsync())
            .unwrap()
            .then((originalPromiseResult) => {
                if (originalPromiseResult.Data[0].AllowLocationInWeb == true) {
                    getUserLocation(0, 0);
                }
                else {

                    addAttendance(getSystemAttendanceTypeId("Attendance"), 1, 0, "0", "0");
                }
            })
            .catch((rejectedValueOrSerializedError) => {
            })
    }
    const addAttendance = useCallback((SystemAttendanceTypeId: any, Status: any, AccountBreakId: any, Latitude: any = "", Longitude: any = "") => {
        const currentDate = new Date();
        const Time = `${currentDate.getHours().toString().padStart(2, '0')}:${currentDate.getMinutes().toString().padStart(2, '0')}:${currentDate.getSeconds().toString().padStart(2, '0')}`;
        const DateOnly = `${currentDate.getFullYear()}-${(currentDate.getMonth() + 1).toString().padStart(2, '0')}-${currentDate.getDate().toString().padStart(2, '0')}`;
        const deviceInfo = getDeviceInformation();

        const ajaxParam = {
            AccountId,
            AccountEmployeeId,
            SystemAttendanceTypeId,
            Status,
            Latitude,
            Longitude,
            SystemEntryModeId: 2,
            TimeIn: Time,
            TimeOut: Time,
            AttendanceDate: DateOnly,
            DeviceInformation: deviceInfo,
            Speed: 0,
            Heading: 0,
            Altitude: 0,
            Accuracy: 0,
            MeanCn0: 0,
            MaxCn0: 0,
            Satellites: 0,
            LocationTimestamp: 0,
            AccountBreakId: (Status === 3 || Status === 4) ? AccountBreakId : '',
            AllowAttendanceOutsideZone: false,
        };
        dispatch(AttendanceAsync(ajaxParam))
            .unwrap()
            .then((originalPromiseResult) => {
                if (originalPromiseResult.StatusCode === "201") {
                    setIsGetAttendance(true);
                } else {
                    ShowToast("Warning", originalPromiseResult.ResponseMessage, "warning", "toast-top-right");
                    setIsGetAttendance(true);
                }
            })
            .catch((rejectedValueOrSerializedError) => {
                ShowToast("error", rejectedValueOrSerializedError, "error", "toast-top-right");
            });
    }, [AccountId, AccountEmployeeId, dispatch]);
    // const addAttendance = (SystemAttendanceTypeId: any, Status: any, AccountBreakId: any, Latitude: any = "", Longitude: any = "") => {
    //     const currentDate = new Date();
    //     const Time = `${currentDate.getHours().toString().padStart(2, '0')}:${currentDate.getMinutes().toString().padStart(2, '0')}:${currentDate.getSeconds().toString().padStart(2, '0')}`;
    //     const DateOnly = `${currentDate.getFullYear()}-${(currentDate.getMonth() + 1).toString().padStart(2, '0')}-${currentDate.getDate().toString().padStart(2, '0')}`;
    //     const deviceInfo = getDeviceInformation();

    //     var ajaxParam = '';
    //     var accountEmployeeAttendanceId = '';
    //     if (Status == 1) {
    //         ajaxParam = JSON.stringify({
    //             AccountEmployeeAttendanceId: 0,
    //             AccountId: 0,
    //             AccountEmployeeId: 0,
    //             SystemAttendanceTypeId: SystemAttendanceTypeId,
    //             Status: Status,
    //             Latitude: Latitude,
    //             Longitude: Longitude,
    //             SystemEntryModeId: 2,
    //             TimeIn: Time,
    //             AttendanceDate: DateOnly,
    //             DeviceInformation: deviceInfo
    //         });
    //     }
    //     if (Status == 2) {
    //         ajaxParam = JSON.stringify({
    //             AccountEmployeeAttendanceId: accountEmployeeAttendanceId,
    //             AccountId: 0,
    //             AccountEmployeeId: 0,
    //             SystemAttendanceTypeId: SystemAttendanceTypeId,
    //             Status: Status,
    //             SystemEntryModeId: 2,
    //             TimeOut: Time,
    //             AttendanceDate: DateOnly,
    //             DeviceInformation: deviceInfo
    //         });
    //     }
    //     if (Status == 3) {
    //         ajaxParam = JSON.stringify({
    //             AccountEmployeeAttendanceId: 0,
    //             AccountId: 0,
    //             AccountEmployeeId: 0,
    //             SystemAttendanceTypeId: SystemAttendanceTypeId,
    //             AccountBreakId: AccountBreakId,
    //             Status: Status,
    //             Latitude: Latitude,
    //             Longitude: Longitude,
    //             SystemEntryModeId: 2,
    //             TimeIn: Time,
    //             AttendanceDate: DateOnly,
    //             DeviceInformation: deviceInfo
    //         });
    //     }
    //     if (Status == 4) {
    //         ajaxParam = JSON.stringify({
    //             AccountEmployeeAttendanceId: accountEmployeeAttendanceId,
    //             AccountId: 0,
    //             AccountEmployeeId: 0,
    //             SystemAttendanceTypeId: SystemAttendanceTypeId,
    //             Status: Status,
    //             SystemEntryModeId: 2,
    //             TimeOut: Time,
    //             AttendanceDate: DateOnly,
    //             DeviceInformation: deviceInfo
    //         });
    //     }
    //     dispatch(AttendanceAsync(ajaxParam))
    //         .unwrap()
    //         .then((originalPromiseResult) => {
    //             if (originalPromiseResult.StatusCode === "200") {
    //                 setIsGetAttendance(true);
    //             } else {
    //                 ShowToast("error", originalPromiseResult.ResponseMessage, "error", "toast-top-right");
    //             }
    //         })
    //         .catch((rejectedValueOrSerializedError) => {
    //             ShowToast("error", rejectedValueOrSerializedError, "error", "toast-top-right");
    //         });
    // }

    const formatTime = (time: any) => {
        let hours = time.getHours();
        const minutes = time.getMinutes().toString().padStart(2, '0');
        const seconds = time.getSeconds().toString().padStart(2, '0');
        const ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12;
        hours = hours ? hours : 12;
        return `${hours}:${minutes}:${seconds} ${ampm}`;
    }

    // const handleStartBreak = (accountBreakId: any) => {
    //     const systemTZ = getSystemTimeZone();

    //     if (systemTZ?.trim().toLowerCase() !== ProfileTimeZoneIANA?.trim().toLowerCase()) {
    //         ShowToast('Error', 'System and TimeLive profile time zone must match.', "error", "toast-top-right");
    //         return;
    //     }
    //     dispatch(getShiftPermissionsAsync())
    //         .unwrap()
    //         .then((originalPromiseResult) => {
    //             if (isAllowedLocationInWeb) {
    //                 setIsOpen(false)
    //                 getUserLocation(1, accountBreakId);

    //             } else {
    //                 setIsOpen(false)
    //                 addAttendance(getSystemAttendanceTypeId("Break"), 3, accountBreakId, "0", "0");
    //             }
    //         })
    //         .catch((rejectedValueOrSerializedError) => {
    //         })
    // }
    const handleStartBreak = useCallback((accountBreakId: any) => {
        if (isTimeZoneMismatched()) return;
        setActiveAccountBreakId(accountBreakId);
        dispatch(getShiftPermissionsAsync())
            .unwrap()
            .then(() => {
                if (isAllowedLocationInWeb) {
                    getUserLocation(1, accountBreakId);
                } else {
                    addAttendance(getSystemAttendanceTypeId("Break"), 3, accountBreakId, "0", "0");
                }
            })
            .catch(() => { })
    }, [isTimeZoneMismatched, dispatch, isAllowedLocationInWeb, getUserLocation, addAttendance]);

    // const handleClockOut = () => {
    //     const systemTZ = getSystemTimeZone();

    //     if (systemTZ?.trim().toLowerCase() !== ProfileTimeZoneIANA?.trim().toLowerCase()) {
    //         ShowToast('Error', 'System and TimeLive profile time zone must match.', "error", "toast-top-right");
    //         return;
    //     }
    //     addAttendance(getSystemAttendanceTypeId("Attendance"), 2, 0);
    // }
    const handleClockOut = useCallback(() => {
        if (isTimeZoneMismatched()) return;
        addAttendance(getSystemAttendanceTypeId("Attendance"), 2, 0, "0", "0");
    }, [isTimeZoneMismatched, addAttendance]);

    // const handleEndBreak = () => {
    //     const systemTZ = getSystemTimeZone();

    //     if (systemTZ?.trim().toLowerCase() !== ProfileTimeZoneIANA?.trim().toLowerCase()) {
    //         ShowToast('Error', 'System and TimeLive profile time zone must match.', "error", "toast-top-right");
    //         return;
    //     }
    //     addAttendance(getSystemAttendanceTypeId("Break"), 4, 0);
    // }
    let latestBreakId = activeAccountBreakId == 0 ? ActiveBreakId : activeAccountBreakId
    const handleEndBreak = useCallback(() => {
        if (isTimeZoneMismatched()) return;
        addAttendance(getSystemAttendanceTypeId("Break"), 4, latestBreakId, "0", "0");
    }, [isTimeZoneMismatched, addAttendance, latestBreakId]);

    const showLocationMessage = () => {
        ShowToast("As per your company policy, you need to allow access to your location for clock-in/clock-out", "", "warning");
    }

    const getSystemAttendanceTypeId = (SystemAttendanceType: any) => {
        switch (SystemAttendanceType) {
            case 'Attendance':
                return "D5E53B7F-3489-4359-9B8E-808143827629";
            case 'Break':
                return "36D3465F-B775-4E36-A00E-A3B5C3AE78D1";
            default:
                return "";
        }
    }

    const convertSecondIntoHoursMinutes = (seconds: any) => {
        let hours = "";
        let minutes = "";
        let hrs = Math.floor(seconds / 3600);
        seconds -= hrs * 3600;
        let mnts = Math.floor(seconds / 60);
        seconds -= mnts * 60;
        if (hrs < 10) {
            hours = "0" + hrs;
        } else {
            hours = String(hrs);
        }
        if (mnts < 10) {
            minutes = "0" + mnts;
        } else {
            minutes = String(mnts);
        }
        const convertedDuration = hours + ":" + minutes;
        return convertedDuration;
    }

    const convertSecondIntoHoursMinutesSeconds = (seconds: any) => {
        let hrs = Math.floor(seconds / 3600);
        seconds -= hrs * 3600;

        let mnts = Math.floor(seconds / 60);
        seconds -= mnts * 60;

        let hrsStr = hrs < 10 ? "0" + hrs : String(hrs);
        let mntsStr = mnts < 10 ? "0" + mnts : String(mnts);
        let secsStr = seconds < 10 ? "0" + seconds : String(seconds);

        const convertedDuration = `${hrsStr}:${mntsStr}:${secsStr}`;
        return convertedDuration;
    };



    return (
        <div className={clsx('app-navbar-item', itemClass)}>
            <div className="card card-custom admin-card">
                <div className="card-header card-drop sticky-top bg-white fixed-top">
                    <div className="card-toolbar align-items-center">
                        {IsAdd && (resultId == 0 ? (
                            <button
                                id="btnCheckIn"
                                className="btn btn-sm btn-success btn-nav-in-out clockin-btn"
                                style={{ padding: '0px 10px', height: 36 }}
                                onClick={() => handleAutoClockIn()}
                            >
                                <i className="ki-outline ki-time text-default fs-2 me-1"></i>
                                <div className="clockin-content">
                                    <span className="" style={{ fontSize: "11px" }}>
                                        {getValueFromResource('Clock In', dispatch, t)}
                                    </span>
                                    <label className="currentTime cursor-pointer" style={{ fontSize: "11px" }}>{formatTime(time)}</label>
                                </div>
                            </button>
                        ) : (
                            (CanStartBreak && CanCheckOut && CanEndBreak == false) ? (
                                <div className="d-flex align-items-center">
                                    <div className="dropdown me-2">
                                        <button
                                            id="btnGetAllBreak"
                                            className="btn btn-secondary btn-bs-btn-font-weight btn-sm fs-7 dropdown-toggle"
                                            data-bs-toggle="dropdown"
                                            style={{ height: 36, padding: '0px 10px' }}
                                        >
                                            <i className="ki-outline ki-time text-default fs-2 me-1"></i>
                                            <span className='fs-7'>
                                                {getValueFromResource('Break', dispatch, t)}
                                            </span>
                                            <i className="fa fa-angle-down" style={{ marginLeft: '5px' }}></i>
                                        </button>
                                        <div
                                            className="dropdown-menu dropdown-menu-right p-0"
                                            style={{ minWidth: '315px', border: '1px solid #ddd', borderRadius: '4px', padding: '18px' }}
                                        >
                                            {Object.keys(breakList).length === 0 ? (
                                                <div className="text-center">
                                                    <span className="text-muted">
                                                        {getValueFromResource('No Breaks Available', dispatch, t)}
                                                    </span>
                                                </div>
                                            ) : (
                                                <>
                                                    <div className="portlet-title" style={{ padding: '10px 10px 0px 10px' }}>
                                                        <div className="caption d-header" style={{ paddingLeft: '15px' }}>
                                                            <span id="spanBreak" className="caption-subject bold blackColor">
                                                                {/* {t('Available Breaks')} */}
                                                                {getValueFromResource('Available Breaks', dispatch, t)}
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div style={{ padding: '0px 15px 15px 15px', maxHeight: '420px', overflowY: 'auto' }}>
                                                        {breakList.map((obj: any, index: any) => {
                                                            const breakType = obj.BreakType;
                                                            const breakDuration = convertSecondIntoHoursMinutes(obj.TotalBreakInSeconds);
                                                            const accountBreakId = obj.AccountBreakId;
                                                            const remainingDuration = convertSecondIntoHoursMinutesSeconds(obj.RemainingSeconds);
                                                            const consumedDuration = convertSecondIntoHoursMinutesSeconds(obj.TotalConsumedSeconds);
                                                            const shiftName = obj.ShiftName;

                                                            return (
                                                                <div key={index} className="my-3 d-body" style={{
                                                                    padding: '15px',
                                                                    borderBottom: '1px solid #eee',
                                                                    marginLeft: '0',
                                                                    marginRight: '0'
                                                                }}>
                                                                    <div className="d-flex justify-content-between align-items-center mb-2" style={{ paddingLeft: '9px' }}>
                                                                        <span className="caption-subject fw-bold blackColor pl-3">{breakType}</span>
                                                                    </div>

                                                                    <div className="row">
                                                                        <div className="col-md-12 col-sm-12 col-xs-12 d-flex align-items-center" style={{ paddingLeft: '18px' }}>
                                                                            <i className="ki-outline ki-time text-default" style={{ fontSize: '2.5rem', color: 'red', marginRight: '10px' }}></i>
                                                                            <div>
                                                                                <div>
                                                                                    <span>{getValueFromResource('Remaining Duration', dispatch, t)}: {remainingDuration}</span>
                                                                                </div>
                                                                                <div>
                                                                                    <span>{getValueFromResource('Consumed Duration', dispatch, t)}: {consumedDuration}</span>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                    <div className="row mb-1">
                                                                        <div className="col-md-3 col-sm-3 col-xs-12 brea  kDuration" style={{ color: 'red' }}>
                                                                            <div className="pull-left" style={{ paddingLeft: '6px' }}>
                                                                                <span>{breakDuration}</span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="d-flex">
                                                                        <div className="col-md-4 col-sm-4 col-xs-12">
                                                                            <div className="pull-left" style={{ paddingLeft: '6px' }}>
                                                                                <button className="btn btn-success btn-sm" onClick={() => handleStartBreak(accountBreakId)}
                                                                                    style={{ padding: '5px' }}
                                                                                >
                                                                                    <span>
                                                                                        {/* Start */}
                                                                                        {getValueFromResource('Start', dispatch, t)}
                                                                                    </span>&nbsp;
                                                                                    <i className="fa fa-play-circle" style={{ color: 'white' }}></i>
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                    <div className="row">
                                                                        <div className="assignedShift" style={{ padding: '7px 0px 8px 15px' }}>
                                                                            <span className="bold" id="spnAssignedShift">
                                                                                {/* {t('Assigned Shift : ')} */}
                                                                                {getValueFromResource('Assigned Shift :', dispatch, t)}
                                                                            </span>
                                                                            <span id="spanShiftName" className="pl-3">{shiftName}</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            );
                                                        })}
                                                    </div>
                                                </>
                                            )}
                                        </div>
                                    </div>

                                    <button
                                        id="btnCheckOut"
                                        className="btn btn-sm btn-danger btn-nav-in-out clockin-btn"
                                        onClick={() => handleClockOut()}
                                        style={{ padding: '0px 10px', height: 36 }}
                                    >
                                        <i className="ki-outline ki-time text-default fs-2 me-1"></i>
                                        <div className="clockin-content">
                                            <span className="" style={{ fontSize: "11px" }}>
                                                {getValueFromResource('Clock Out', dispatch, t)}
                                            </span>
                                            <label className="currentTime cursor-pointer" style={{ fontSize: "11px" }}>{formatTime(time)}</label>
                                        </div>
                                    </button>
                                </div>
                            ) : (
                                <button
                                    id="btnCheckOut"
                                    className="btn btn-sm btn-danger btn-nav-in-out clockin-btn"
                                    onClick={() => handleEndBreak()}
                                    style={{ padding: '0px 10px', height: 36 }}
                                >
                                    <i className="ki-outline ki-time text-default fs-2 me-1"></i>
                                    <div className="clockin-content">
                                        <span style={{ fontSize: "11px" }}>
                                            {getValueFromResource('Break Out', dispatch, t)}
                                        </span>
                                        <label className="currentTime" style={{ fontSize: "11px" }}>{formatTime(time)}</label>
                                    </div>
                                </button>
                            )
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default TimeinTimeout